module.exports = __webpack_public_path__ + "static/img/hb_23-min.3c2e215.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_23-min.png
// module id = 8EJs
// module chunks = 1